var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-share"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M13.744-16A2.256,2.256,0,0,1,16-13.744v8.205a2.256,2.256,0,0,1-2.256,2.256H12.717v1.144A2.139,2.139,0,0,1,10.732-.005L10.579,0h-7.5A3.077,3.077,0,0,1,.005-2.9L0-3.077v-7.5a2.139,2.139,0,0,1,1.986-2.134l.153-.005H3.282v-1.026A2.256,2.256,0,0,1,5.538-16ZM3.282-11.488H2.139a.909.909,0,0,0-.9.8l-.006.106v7.5a1.846,1.846,0,0,0,1.7,1.841l.144.006h7.5a.909.909,0,0,0,.9-.8l.006-.106V-3.283H5.538A2.256,2.256,0,0,1,3.282-5.538Zm10.462-3.281H5.538a1.026,1.026,0,0,0-1.026,1.026v8.205A1.026,1.026,0,0,0,5.538-4.513h8.205a1.026,1.026,0,0,0,1.026-1.026v-8.205A1.026,1.026,0,0,0,13.744-14.769ZM11.692-8.615A.615.615,0,0,1,12.308-8a.616.616,0,0,1-.524.609l-.091.007H7.59A.615.615,0,0,1,6.974-8,.616.616,0,0,1,7.5-8.609l.091-.007ZM12.423-12a.543.543,0,0,1,.577.5.543.543,0,0,1-.577.5H8.577A.543.543,0,0,1,8-11.5a.543.543,0,0,1,.577-.5h3.846Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path-share)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-5-21H21V5H-5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.9c2350a6eae34ac0ffee14622aa42102.svg";
export { ForwardRef as ReactComponent };